import { render, staticRenderFns } from "./ManageSites.vue?vue&type=template&id=cca507a4&"
import script from "./ManageSites.vue?vue&type=script&lang=js&"
export * from "./ManageSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports